/*
 * @Author: hzc
 * @Date: 2024-12-09 09:25:17
 * @LastEditors: hzc
 * @LastEditTime: 2025-07-11 19:46:22
 * @Description: -
 */
import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import "./registerServiceWorker";
import { createI18n } from "vue-i18n";
import zhCN from "./lang/zh-CN";
import en from "./lang/en";
import fr from "./lang/fr";
import ar from "./lang/ar";
import es from "./lang/es";
import id from "./lang/id";
import pt from "./lang/pt";
import kr from "@/lang/kr";
import jp from "@/lang/jp";
import de from "@/lang/de";

import "@icon-park/vue-next/styles/index.css";
import "prosemirror-view/style/prosemirror.css";
import "animate.css";

import "@/assets/styles/prosemirror.scss";
import "@/assets/styles/global.scss";
import "@/assets/styles/antd.scss";
import "@/assets/styles/font.scss";

import Icon from "@/plugins/icon";
import Directive from "@/plugins/directive";

const i18n = createI18n({
  legacy: false,
  fallbackLocale: "en", // set fallback locale
  locale: "en", // 初始化中文
  messages: {
    "zh-CN": zhCN,
    en: en,
    fr: fr,
    ar: ar,
    es: es,
    id: id,
    pt: pt,
    kr: kr,
    jp: jp,
    de: de,
  },
});
import VueGtag from "vue-gtag";
const app = createApp(App);

// main.js 文件
import VueLazyload from "vue-lazyload";
// Vue.use(VueLazyload) //无配置项
// 配置项
const loadimage = require("/public/logo/logo-grey-card.png");
// const errorimage = require('assets/img/common/error.gif')
app.use(VueLazyload, {
  preLoad: 1.3, //预加载的宽高比
  loading: loadimage, //图片加载状态下显示的图片
  // error: errorimage, //图片加载失败时显示的图片
  attempt: 3, // 加载错误后最大尝试次数
});
// https://matteo-gabriele.gitbook.io/vue-gtag/
app.use(VueGtag, {
  config: { id: "G-T7R2V4LPQD" },
});

app.use(Icon);
app.use(Directive);
app.use(i18n);

app.use(createPinia());
app.mount("#app");
